<template>
    <div class="dialog-container">
        <el-dialog :visible.sync="serviceVisible" width="500px" custom-class="service-dialog" :before-close="close">
            <div slot="title" class="title-dialog">小程序暂停服务</div>
        	<div class="service">
                <div class="service-paused-warning">
                    <p>1. 暂停服务后，所有用户无法使用小程序，不影响小程序的提交审核和发布</p>
                    <p>2. 如需恢复服务，需在设置页面手动恢复</p>
                    <p>3. 客户端将展示暂停服务原因及预计恢复时间，查看<a @click="showPreview">展示效果</a></p>
                </div>
                <div class="service-paused-detail">
                    <template v-if="isMultipleChannel">
                        <div class="detail-item">
                            <label class="service-label">选择渠道</label>
                            <el-select v-model="serviceInfo.channel" @change="channelChange" value-key="channelKey" size="mini" style="display: inline-block;width: 279px;">
                                <el-option v-for="item in suspendInfoList" :key="item.channelKey" :label="channelLabel(item.channelName, item.status)" :value="item"></el-option>
                            </el-select>
                        </div>
                    </template>
                    <template v-if="!isMultipleChannel || serviceInfo.channel && serviceInfo.channel.status === 0">
                        <div class="detail-item">
                            <label class="service-label">暂停原因</label>
                            <el-select v-model="serviceInfo.reason" size="mini" style="display: inline-block;width: 279px;">
                                <el-option v-for="(value, key) in reasonList" :key="key" :label="value.label" :value="parseInt(key, 10)"></el-option>
                            </el-select>
                        </div>
                        <div class="detail-item" v-if="serviceInfo.reason !== 2">
                            <label class="service-label">显示预计恢复时间</label>
                            <el-radio-group v-model="serviceInfo.isRecoveryTime">
                                <el-radio size="mini" :label="1"><span class="time-info">显示</span></el-radio>
                                <el-radio size="mini" :label="2"><span class="time-info">未能确定恢复时间</span></el-radio>
                            </el-radio-group>
                        </div>
                        <div class="detail-item" v-if="timeVisible">
                            <label class="service-label">选择预计恢复时间</label>
                            <el-date-picker
                                v-model="serviceInfo.realTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                size="mini"
                                :picker-options="pickDate"
                                style="display: inline-block;width: 279px;"
                                @change="checkTime"
                                >
                            </el-date-picker>
                        </div>
                        <div v-if="errorInfo" class="error-info">{{errorInfo}}</div>
                    </template>
                </div>
            </div>
            <div slot="footer" class="op-dialog">
                <btn :type="1" info="取消" @click="close"></btn>
                <btn :type="0" v-if="!isMultipleChannel || isMultipleChannel && serviceInfo.channel" :info="btnInfo" @click="confirmPausedService"></btn>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import dao from '@/lib/dao';
import Btn from '@/components/Button.vue';
import Confirm from '@/components/Confirm.vue';
   
export default {
	props:{
	    serviceVisible: {
	        type: Boolean,
	        default: false
	    },
        appInfo: {
            type: Object,
            default() {
                return {
                    appId: ''
                }
            },
        },
        isMultipleChannel: {
            type: Boolean,
            default: false
        },
        suspendInfoList: {
            type: Array,
            default: []
        },
	},
    components: {
        Btn,
        Confirm
    },
    computed: {
        timeVisible() {
            return this.serviceInfo.reason !== 2 && this.serviceInfo.isRecoveryTime !== 2
        },
        btnInfo(){
            if(this.isMultipleChannel){
                switch (this.status) {
                    case 1:
                        return '恢复服务'
                    case 0:
                        return '暂停服务'
                    default:
                        return ''
                }
            }
            return '暂停服务'
        },
    },
	data() {
		return {
            appId: '',
            serviceInfo: {
                channel: '',
                reason: 0,         
                isRecoveryTime: 1,
                realTime: new Date(new Date().setHours(12, 0, 0, 0)).getTime() + 86400000
            },
            status: '',
            reasonList: [
                {
                    label: '系统更新维护',
                    value: 0
                },
                {
                    label: '系统故障',
                    value: 1
                },
                {
                    label: '其他原因',
                    value: 2
                }
            ],
            pickDate: {
                disabledDate(time) {
                    let nowDate = Date.now() / 1000;
                    return time.getTime() < Date.now() - 86400000
                }
            },
            errorInfo: ''
		}
	},
	methods: {
        close() {
            this.$emit('close')
        },
        showPreview() {
            this.$emit('close')
            this.$emit('showPreview')
        },
        checkTime() {
            if ((this.serviceInfo.realTime).getTime() < new Date().getTime()) {
                this.errorInfo = '时间不可低于当前时间';
            } else {
                this.errorInfo = '';
            }
        },
        confirmPausedService() {
            if (this.errorInfo) {
                return false
            } else {
                this.$emit('close')
                if(this.isMultipleChannel) {
                    switch (this.status) {
                        case 1:
                            this.$emit('openConfirm', 'resumService', this.serviceInfo)
                            return;
                        case 0:
                            this.$emit('openConfirm', 'suspendService', this.serviceInfo)
                            return
                        default:
                            return;
                    }
                }
                this.$emit('openConfirm', 'suspendService', this.serviceInfo)
            }
        },
        channelChange(value) {
            this.status = value.status
        },
        channelLabel(name = '', status) {
            switch (status) {
                case 1:
                    return `【已暂停】${name}`
                case 0:
                    return `【未暂停】${name}`
                default:
                    return name
            }
        }
    }
}
</script>
<style lang="less" scoped>
.dialog-container {
    padding: 5px 5px 0;
    color: #5C667E;
    border-radius: 2px;
    .service-dialog {

        .title-dialog {
            color: #5C667E;
        }
        .op-dialog {
            text-align: center;
            .add {
                margin-right: 10px;
                
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .service {
            border: none;
            margin: -30px -20px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            padding-left: 30px;

           .service-paused-warning {
                padding-top: 10px;
                padding-bottom: 20px;
                > p {
                    margin-bottom: 12px;
                    line-height: 17px;
                }
                a {
                    color: #789AFF;
                    line-height: 17px;
                    cursor: pointer;
                }
            }
            .service-paused-detail {
                font-size: 12px;
                padding: 0;
               .detail-item {
                    margin-bottom: 14px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                    .service-label {
                        display: inline-block;
                        width: 100px;
                        text-align: right;
                        margin-right: 10px;
                        margin-bottom: 20px;
                    }
                    .time-info {
                        font-size: 12px;
                        color: #5C667E;
                    }
                }
                .error-info {
                    font-size: 10px;
                    margin-left: 120px;
                    margin-top: -20px;
                    color: #FF7B58;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/basic/SuspendService.vue